/*
 * please follow the wiki: http://wiki.corp.qunar.com/pages/viewpage.action?pageId=105923056
 * @providesModule QImageSet
 */

const QImageSet = {
    noDataImage: 'https://s.qunarzz.com/ordercenter_mobile/images/order_login.png',//***
    loading: 'https://picbed.qunarzz.com/d6d5abe2c3d99f92860a3d461aec2cbf.png',//***
    // noNetwork: 'https://picbed.qunarzz.com/f80c53076e104df112c0a1ae46771973.png',//*** 
    // noOrder: 'https://picbed.qunarzz.com/57493e711659e395874e24f78adf3bee.png',//***
    centerLoadingViewBg:'https://picbed.qunarzz.com/3c8c5f80279a3b1b17d0475c0aadb556.png',//***

    //按钮列表弹窗
    more_btn_list_top: 'https://picbed.qunarzz.com/7e4392a7e7c4f62c98b652ce4ac15300.png',
    more_btn_list_bottom: 'https://picbed.qunarzz.com/9074cff8e53ee259d46923f11b229459.png',
    more_btn_list_center: 'https://picbed.qunarzz.com/b90cf990e685af8106554dd67fe5b749.png',

    //更多按钮
    more_btn_icon: 'https://picbed.qunarzz.com/5a9dcc5324453c86d03f4c1f78ef38f6.png',

    //客服按钮
    service_btn_icon: 'https://picbed.qunarzz.com/ef2f8d363ab562fd8ad9511476ecb175.png',

    //客服右侧列表左方阴影
    list_left_shadow: 'https://picbed.qunarzz.com/6de3e5b0d4397fb53641f47cdecbb557.png',

    //扫码住红包icon
    cashback_gift_icon: 'https://picbed.qunarzz.com/7d66117fa3d99fccf34bc2ea91a5eca4.png',

    into_car_icon: 'https://picbed.qunarzz.com/f854eeac3b64b896fa56b30e0d8d3cd4.png',
    out_car_icon: 'https://picbed.qunarzz.com/7f855e3d4691b446e7db6c717e690a32.png',
    disable_into_car_icon: 'https://picbed.qunarzz.com/97308002ed5da2c1e7b9b86862201179.png',
    disable_out_car_icon: 'https://picbed.qunarzz.com/42efe5ed63a537d6afb5dd47f046e025.png',

    member_card_icon: 'https://picbed.qunarzz.com/217c0cfb0b78b5632449b13926c9b792.png',
    member_card_line: 'https://picbed.qunarzz.com/fa42a967cf3e204908774cc0aa0b830b.png',

    price_bubble_bg_left: 'https://s.qunarzz.com/f_cms/2022/1660736589559_108382059.png',
    price_bubble_bg_middle: 'https://s.qunarzz.com/f_cms/2022/1660735904323_434192057.png',
    price_bubble_bg_right: 'https://s.qunarzz.com/f_cms/2022/1660736622090_75392138.png'
};

export default QImageSet;
